import { render, staticRenderFns } from "./MunicipalitiesImport.vue?vue&type=template&id=e23ddcce&"
import script from "./MunicipalitiesImport.vue?vue&type=script&lang=js&"
export * from "./MunicipalitiesImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports